"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var paymentEwayStyles_1 = require("./paymentEwayStyles");
var DefaultButton_1 = require("../../../../../../common/components/presentation/Buttons/DefaultButton");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var PaymentEway_1 = require("./PaymentEway");
var usePaymentEway_1 = require("../../../hooks/usePaymentEway");
var useCheckoutContext_1 = require("../../../../../common/hooks/useCheckoutContext");
var PaymentEwayContainer = function () {
    var _a, _b, _c;
    var styles = paymentEwayStyles_1.default();
    var deal = useCheckoutContext_1.default().deal;
    var _d = usePaymentEway_1.usePaymentEway(), handleInitPayment = _d.handleInitPayment, initPaymentData = _d.initPaymentData, initPaymentError = _d.initPaymentError, loading = _d.loading, paymentAmount = _d.paymentAmount, isPaymentFailed = _d.isPaymentFailed;
    var buttonText = isPaymentFailed
        ? 'trans__checkout__payment_page__try_again_CTA'
        : 'trans__checkout__next_step__payment_page__proceed_to_order_CTA';
    return (<core_1.Box className={styles.container}>
      <PaymentEway_1.default initError={initPaymentError} paymentAmount={paymentAmount} isPaymentFailed={isPaymentFailed} loading={loading} refundableState={(_c = (_b = (_a = deal) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.paymentFee) === null || _c === void 0 ? void 0 : _c.refundableState}/>
      {!initPaymentData && (<DefaultButton_1.default className={[styles.payButton]} dataTest="button:checkout:eway" variant="contained" onClick={handleInitPayment} disabled={loading}>
          <Translation_1.default id={buttonText} values={{ reservationFee: paymentAmount }}/>
        </DefaultButton_1.default>)}
    </core_1.Box>);
};
exports.default = PaymentEwayContainer;
